/* unplugin-vue-components disabled */import script from "./DeptTreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptTreeItem.vue?vue&type=script&setup=true&lang=js"

import "./DeptTreeItem.vue?vue&type=style&index=0&id=a230153a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a230153a"]])

export default __exports__